// ============================================================================
// AREA ENDPOINTS
// ============================================================================
// BASE_PATH must match the backend controller route token (AreaController → /Area).

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const AREA_BASE_PATH = '/Area';

export const areaEndpoints = {
  list: () => buildEndpoint(AREA_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${AREA_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${AREA_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(AREA_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${AREA_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${AREA_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${AREA_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default areaEndpoints;
